import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */

export const styles = {
  locationMilestone: {
    color: 'secondary.main',
    width: 28,
    height: 28,
    zIndex: 1000,
  },
  attendanceMilestone: {
    color: 'warning.main',
    width: 28,
    height: 28,
    zIndex: 1000,
  },
  iconWrapper: {
    zIndex: 100,
    width: 32,
    height: 32,
  },
  countWrapper: {
    zIndex: 1000,
    position: 'absolute',
    width: 28,
    textAlign: ' center',
    marginTop: 0.6,
  },
  badgesWrapper: {
    position: 'relative',
  },
  badgeItem: {
    marginRight: 0.5,
  },
}
